var poll_header_default = {
  "title": "E82AJ",
  "image": "c2VYr",
  "webview": "x3yMm"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
